// Import: Middleware Action & Custom Types
import { CLEAN_OFFERS, CLEAN_OFFERS_ERROR } from "_models/redux/types";

// Action function
export const cleanOffersAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_OFFERS,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_OFFERS_ERROR,
            payload: undefined,
        });
    }
};
